<!-- <div *ngIf="listItem.status != 's00_closed'" >
  <ng-container *ngIf="listItem.active; else withoutLink">
    <a [routerLink]="['/performance',listItem?.eventCode,listItem?.performanceCode,region,lang]">
      <div class="performance-listing" [ngClass]="performanceItemClasses()">
        <div class="date-box">
          <span class="day">{{date|localizedDate:dayFormat}}</span>
          <span class="month">{{date|localizedDate:monthFormat}}</span>
        </div>
        <div class="divider">&nbsp;</div>
        <div fxLayout="column">
          <div fxLayout="row" fxLayoutGap="5px" class="info-group">
            <mat-icon class="time-icon">schedule</mat-icon>
            <span class="time">{{date|localizedDate:timeFormat}}</span>
            <mat-basic-chip class="status" [ngClass]="statusClasses()">{{statusText}}</mat-basic-chip>
          </div>
          <div fxLayout="row" class="performance-listing-venue">
            {{listItem?.venueName}}
          </div>
        </div>
        <div class="campaign-title-holder" *ngIf="listItem?.campaignTitle">
          <mat-basic-chip class="campaign-title">{{listItem?.campaignTitle}}</mat-basic-chip>
        </div>
        <div class="chevron-right" *ngIf="listItem?.active">

          <mat-icon>chevron_right</mat-icon>
        </div>
      </div>
    </a>
  </ng-container>

  <ng-template  #withoutLink>
      <div class="performance-listing" [ngClass]="performanceItemClasses()">
        <div class="date-box">
          <span class="day">{{date|localizedDate:dayFormat}}</span>
          <span class="month">{{date|localizedDate:monthFormat}}</span>
        </div>
        <div class="divider">&nbsp;</div>
        <div fxLayout="column">
          <div fxLayout="row" fxLayoutGap="5px" class="info-group">
            <mat-icon class="time-icon">schedule</mat-icon>
            <span class="time">{{date|localizedDate:timeFormat}}</span>
            <mat-basic-chip class="status" [ngClass]="statusClasses()">{{statusText}}</mat-basic-chip>
          </div>
          <div fxLayout="row" class="performance-listing-venue">
            {{listItem?.venueName}}
          </div>
        </div>
        <div class="chevron-right" *ngIf="listItem?.active">
          <mat-icon>chevron_right</mat-icon>
        </div>
      </div>
  </ng-template>
</div>   -->

<div>
  <a [href]="generateHref(listItem?.eventCode, region, lang, listItem?.keyUrlText)">
    <div class="performance-listing">
      <div class="date-box" *ngIf="(lastDate|localizedDate:dayFormat) == (firstDate|localizedDate:dayFormat)">
        <span class="day">{{firstDate|localizedDate:dayFormat}}</span>
        <span class="month">{{firstDate|localizedDate:monthFormat}}</span>
      </div>
      <div class="date-box" *ngIf="(lastDate|localizedDate:dayFormat) !== (firstDate|localizedDate:dayFormat)">
        <span><mat-icon>calendar_month</mat-icon></span>
        <!--
        <span class="day">{{firstDate|localizedDate:dayFormat}}</span>
        <span class="month">{{firstDate|localizedDate:monthFormat}}</span>
        <span class="first-last-day">
          {{ firstDate | localizedDate:'d MMM' }} - {{ lastDate | localizedDate:'d MMM' }}
        </span>
        -->

      </div>
      <!-- <div class="date-box date-divider" *ngIf="(lastDate|localizedDate:dayFormat) !== (firstDate|localizedDate:dayFormat)">
        -
      </div>
      <div class="date-box" *ngIf="(lastDate|localizedDate:dayFormat) !== (firstDate|localizedDate:dayFormat)">
        <span class="day">{{lastDate|localizedDate:dayFormat}}</span>
        <span class="month">{{lastDate|localizedDate:monthFormat}}</span>
      </div> -->
      <div class="divider">&nbsp;</div>
      <div fxLayout="column">
        <div fxLayout="row" fxLayoutGap="5px" class="info-group">
          <!-- <mat-icon class="time-icon">schedule</mat-icon> -->
          <span class="event-name">{{listItem?.eventName}}</span>
          <!-- <span class="time">{{date|localizedDate:timeFormat}}</span> -->
          <mat-basic-chip class="status" [ngClass]="statusClasses()">{{statusText}}</mat-basic-chip>
        </div>
        <div fxLayout="row" class="performance-listing-venue">
          {{listItem?.venueName}}, {{listItem?.venueCity}}
        </div>
        <div fxLayout="row" class="performance-listing-price" *ngIf="listItem?.minPrice && listItem.minPrice !== '0'">
          <mat-icon>local_offer</mat-icon>
          <span><small class="price-prefix">{{ 'home.labels.pricePrefix' | translate }}</small>{{ listItem?.minPrice | customCurrency }}<small class="price-suffix">{{ 'home.labels.priceSuffix' | translate }}</small></span>
        </div>
      </div>
      <div class="campaign-title-holder" *ngIf="listItem?.campaignTitle">
        <mat-basic-chip class="campaign-title">{{listItem?.campaignTitle}}</mat-basic-chip>
      </div>
      <div class="chevron-right" *ngIf="listItem?.active">
        <span class="find-ticket">
          <mat-icon>chevron_right</mat-icon>
        </span>
      </div>
    </div>
  </a>
</div>
